import { useEffect } from "react";
import {
  fetchChooseUs,
  fetchHomeAbout,
  fetchHomeHighlights,
  fetchHomeMessage,
  fetchHomeSliders,
  // fetchHomeTestimonial,
  // fetchHomeTestimonialHeader,
  fetchHomeTiles,
  fetchTilesHeader,
} from "../api/HomeApi";
// import {
//   fetchfacultiesHeader,
//   fetchfacultiesMember,
// } from "../api/FacultiesApi";
import { fetchFacilitiesList } from "../api/FacilitiesApi";
import { fetchActivitiesList } from "../api/ActivitiesApi";
import { fetchgalleryHeader, fetchgalleryImages } from "../api/GalleryApi";
import {
  fetchAboutBanner,
  // fetchcertificateHeader,
  // fetchcertificateList,
  fetchjoincommunitiesHeader,
  fetchobjective,
  fetchvision,
  fetchvisionObjectiveHeader,
  fetchwhyEga,
} from "../api/AboutApi";
import { fetchcontactFormHeader, fetchcontactHeader } from "../api/ContactApi";
import { fetchAllBanner, fetchCalendar } from "../api/SchoolDetailsApi";
import { fetchPolicies } from "../api/AdmissionApi";

export const FetchAllApi = ({ schoolDetailsData, setAllData, setLoading }) => {
  useEffect(() => {
    setLoading(true);

    if (schoolDetailsData.length === 0) {
      Promise.all([
        fetchHomeSliders(), 
        fetchTilesHeader(),
        fetchHomeTiles(),
        fetchHomeAbout(),
        fetchHomeMessage(),
        fetchChooseUs(),
        fetchHomeHighlights(),
        // fetchHomeTestimonialHeader(),
        // fetchHomeTestimonial(),
        // fetchfacultiesHeader(),
        // fetchfacultiesMember(),
        fetchFacilitiesList(),
        fetchActivitiesList(),
        fetchgalleryHeader(),
        fetchgalleryImages(),
        fetchAboutBanner(),
        fetchvisionObjectiveHeader(),
        fetchvision(),
        fetchobjective(),
        fetchwhyEga(),
        // fetchcertificateHeader(),
        // fetchcertificateList(),
        fetchjoincommunitiesHeader(),
        fetchcontactHeader(),
        fetchcontactFormHeader(),
        fetchPolicies(),
        fetchCalendar(),
        fetchAllBanner(),
      ])
        .then(
          ([
            homeSliderData,
            homeTilesHeaderData,
            homeTilesData,
            homeAboutData,
            homeMessageData,
            homeChooseUsData,
            homeHighlightsData,
            // homeTestimonialHeaderData,
            // homeTestimonialData,
            // facultyHeader,
            // facultyMember,
            facilitiesList,
            activities,
            galleryHeader,
            galleryImage,
            banner,
            visionObjectiveHeader,
            visionData,
            objectiveData,
            whyEgaData,
            // certificateHeader,
            // certificateList,
            joinCommunityHeader,
            contactHeader,
            contactFromHeader,
            policiesData,
            calendarData,
            allBannerData,
          ]) => {
            setAllData((prev) => ({
              ...prev,
              // /
              sliderData: homeSliderData,
              tilesHeaderData: homeTilesHeaderData,
              tilesData: homeTilesData,
              aboutData: homeAboutData,
              chairmenData: homeMessageData,
              chooseUsData: homeChooseUsData,
              highlightsData: homeHighlightsData,
              // testimonialHeaderData: homeTestimonialHeaderData,
              // testimoniaData: homeTestimonialData,
              // faculty
              // facultyHeaderData: facultyHeader,
              // facultyMemberData: facultyMember,
              // facilities
              facilitiesData: facilitiesList,
              // activities 
              activitiesData: activities,
              // gallery
              galleryHeaderData: galleryHeader,
              galleryImagesData: galleryImage,
              // about
              bannerData: banner,
              visionObjectiveHeaderData: visionObjectiveHeader,
              visionData: visionData,
              objectiveData: objectiveData,
              whyEgaData: whyEgaData,
              // certificateHeaderData: certificateHeader,
              // certificateListData: certificateList,
              joinCommunityHeaderData: joinCommunityHeader,
              // contact
              contactHeaderData: contactHeader,
              contactFormHeaderData: contactFromHeader,
              // 
              policiesData: policiesData,
              calendarData: calendarData,
              allBannerData: allBannerData,
            }));

            setTimeout(() => {
              setLoading(false);
            }, 500);
          }
        )
        .catch(() => {
          console.error("Server Error");
          setTimeout(() => {
            setLoading(false);
          }, 500);
        });
    } else {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  }, [schoolDetailsData.length, setAllData, setLoading]);
};
